// Camera feature state key
export const REDUCER_ANOMALY_ID = 'anomalies';
export const REDUCER_LIVE_ANOMALY_ID = 'liveAnomalies';
